import { Modal, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";

import { ModalContext } from "./ModalContextProvider";

const ModalWrapper = () => {
  const theme = useTheme();
  const [_, [Component, modalProps, contextProps]] = useContext(ModalContext);
  const { onClose } = contextProps ?? {};

  const [setModal] = useContext(ModalContext);
  const [key, setKey] = useState(new Date().toISOString());
  useEffect(() => {
    setKey(new Date().toISOString());
  }, [Component, modalProps]);

  const handleClose = () => {
    setModal([undefined, undefined, contextProps]);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      aria-labelledby="modal-title"
      container={theme.components?.MuiModal?.defaultProps?.container}
      open={!!Component}
      onClose={handleClose}
    >
      {Component ? (
        <Component handleClose={handleClose} key={key} {...modalProps} />
      ) : (
        <></>
      )}
    </Modal>
  );
};

export default ModalWrapper;
